import get from 'lodash/get'
import reduce from 'lodash/reduce'
import { default as deserialize } from 'app/utils/deserialize'
import { fetch } from 'app/utils/data'
import FormErrors from 'app/utils/form_errors'

export default {
  namespaced: true,

  state: {
    definitions: null,
    canByRole: {}
  },

  getters: {
    definitions: (state) => state.definitions,
    canByRole: (state) => state.canByRole
  },

  mutations: {
    definitionsFetched(state, { definitions }) {
      state.definitions = definitions

      // Dynamically discover roles from definitions
      const rolesSet = new Set()

      Object.values(definitions).forEach((actions) => {
        Object.values(actions).forEach((allows) => {
          Object.keys(allows).forEach((role) => {
            rolesSet.add(role)
          })
        })
      })

      const roles = Array.from(rolesSet)

      // Calculate permissions for each role
      roles.forEach((role) => {
        state.canByRole[role] = reduce(
          definitions,
          (acc, actions, objectName) => {
            const actionsAllowed = reduce(
              actions,
              (acc2, allows, actionName) => {
                acc2[actionName] = allows[role]

                return acc2
              },
              {}
            )

            acc[objectName] = actionsAllowed

            return acc
          },
          {}
        )
      })
    },

    resetState(state) {
      state.definitions = null
      state.canByRole = {}
    }
  },

  actions: {
    async fetchPolicies({ commit }) {
      try {
        const response = await fetch({ url: `/api/policies` })

        const policies = await deserialize(response.data)

        commit('definitionsFetched', { definitions: policies.definitions })

        return policies
      } catch (error) {
        throw new FormErrors(get(error, 'response.data.errors', [{ detail: "Policies? We don't need no stinkin policies." }]))
      }
    }
  }
}
